

export class Base {

    id : string;

    created_at : Date;

    updated_at : Date;

}